
import React from "react";

var ClientSettingsStateContext = React.createContext();
var ClientSettingsDispatchContext = React.createContext();

function clientSettingsReducer(state, action) {
  switch (action.type) {
    case "SET_ARTICLE_PARAMETERS":
      localStorage.setItem("articleParameters", JSON.stringify(action.payload));
      return { ...state, articleParameters: action.payload };
    case "SET_COMPANY_PARAMETERS":
      localStorage.setItem("companyParameters", JSON.stringify(action.payload));
      return { ...state, companyParameters: action.payload };
    case "SET_TECHNICAL_PARAMETERS":
      localStorage.setItem("technicalParameters", JSON.stringify(action.payload));
      return { ...state, technicalParameters: action.payload };
    case "SET_SALES_PARAMETERS":
      localStorage.setItem("salesParameters", JSON.stringify(action.payload));
      return { ...state, salesParameters: action.payload };
    case "SET_RGPD_PARAMETERS":
        localStorage.setItem("rgpdParameters", JSON.stringify(action.payload));
        return { ...state, rgpdParameters: action.payload };
    case "SET_BACKGROUND_PICTURE":
      return { ...state, backgroundPicture: action.payload };
    case "SET_CLIENT_CURRENCY":
      localStorage.setItem("clientCurrencyData", JSON.stringify(action.payload));
      return { ...state, clientCurrencyData: action.payload };
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}

// we created two different providers (one for global state and the other for dispatch (setting global state))
//  best practice => + Fail fast and catch the exception using useClientSettingsState() and useClientSettingsDispatch()
function ClientSettingsProvider({ children }) {
  var [state, dispatch] = React.useReducer(clientSettingsReducer, {
    articleParameters:
      localStorage.getItem('articleParameters') && JSON.parse(localStorage.getItem("articleParameters")) ?
        JSON.parse(localStorage.getItem("articleParameters")) :
        {
          MARK_LABEL: "",
          MARK_MANDATORY: "",
          CLASSIFICATION1_LABEL: "",
          CLASSIFICATION1_MANDATORY: "",
          CLASSIFICATION2_LABEL: "",
          CLASSIFICATION2_MANDATORY: "",
          CLASSIFICATION3_LABEL: "",
          CLASSIFICATION3_MANDATORY: "",
          FREE_FIELD1_LABEL: "",
          FREE_FIELD2_LABEL: "",
          DEFAULT_TVA: "",
        },
    companyParameters:
      localStorage.getItem('companyParameters') && JSON.parse(localStorage.getItem("companyParameters")) ?
        JSON.parse(localStorage.getItem("companyParameters")) :
        {
          SOCIAL_REASON: "",
          COMMERCIAL_NAME: "",
          ADRESS1: "",
          ADRESS2: "",
          ADRESS3: "",
          CP: "",
          CITY: "",
          COUNTRY: "",
          PHONE_NUMBER: "",
          EMAIL: "",
          COMPANY_NUMBER: "",
          TVA_NUMBER: "",
          NAF_CODE: "",
          FORM: "",
          CAPITAL: "",
          CURRENCY: "",
          END_ACCOUNTING_MONTH: "",
        },
    technicalParameters:
      localStorage.getItem('technicalParameters') && JSON.parse(localStorage.getItem("technicalParameters")) ?
        JSON.parse(localStorage.getItem("technicalParameters")) :
        {
          DOSSIER_PASSWORD: "",
          COMPANY_NUMBER_LABEL: "",
          TVA_NUMBER_LABEL: "",
          NAF_CODE_LABEL: "",
          FORM_LABEL: "",
          CAPITAL_LABEL: "",
          MAX_PHOTOS_SIZE: "",
          MAX_VIDEOS_SIZE: "",
          MAX_DOCUMENTS_SIZE: "",
          TIMEZONE: ""
        },
    salesParameters:
      localStorage.getItem('salesParameters') && JSON.parse(localStorage.getItem("salesParameters")) ?
        JSON.parse(localStorage.getItem("salesParameters")) :
        {
          CUSTOMER_PROVENANCE_LABEL: "",
          CUSTOMER_PROVENANCE_MANDATORY: "",
          POSTAL_CODE_MANDATORY: "",
          CUSTOMER_DISCOUNT_LABEL_MANDATORY: "",
          CUSTOMER_RETURN_LABEL_MANDATORY: "",
        },

    rgpdParameters:
      localStorage.getItem('rgpdParameters') && JSON.parse(localStorage.getItem("rgpdParameters")) ?
        JSON.parse(localStorage.getItem("rgpdParameters")) :
        {
          RGPD_ACTIF: false,
          RGPD_RESPONSABLE_DPO: "",
          RGPD_MENTION_INFORMATION: "",
          RGPD_PRINTING_INFORMATION: false,
          RGPD_MAIL_SENDING_INFORMATION: false,
        },
    backgroundPicture: "",
    clientCurrencyData:
      localStorage.getItem('clientCurrencyData') && JSON.parse(localStorage.getItem("clientCurrencyData")) ?
        JSON.parse(localStorage.getItem("clientCurrencyData")) :
        { precision: 2 },
  });
  return (
    <ClientSettingsStateContext.Provider value={state}>
      <ClientSettingsDispatchContext.Provider value={dispatch} >
        {children}
      </ClientSettingsDispatchContext.Provider>
    </ClientSettingsStateContext.Provider>
  );
}

function useClientSettingsState() {
  var context = React.useContext(ClientSettingsStateContext);
  if (context === undefined) {
    throw new Error("useClientSettingsState must be used within a ClientSettingsProvider");
  }
  return context;
}

function useClientSettingsDispatch() {
  var context = React.useContext(ClientSettingsDispatchContext);
  if (context === undefined) {
    throw new Error("useClientSettingsDispatch must be used within a ClientSettingsProvider");
  }
  return context;
}

export {
  ClientSettingsProvider, useClientSettingsState, useClientSettingsDispatch, setArticleParameters, setBackgroundPiture,
  setCompanyParameters, setTechnicalParameters, setSalesParameters, setClientCurrency, setRgpdParameters
};

function setArticleParameters(dispatch, data) {
  dispatch({
    type: "SET_ARTICLE_PARAMETERS",
    payload: data
  });
}

function setCompanyParameters(dispatch, data) {
  dispatch({
    type: "SET_COMPANY_PARAMETERS",
    payload: data
  });
}

function setTechnicalParameters(dispatch, data) {
  dispatch({
    type: "SET_TECHNICAL_PARAMETERS",
    payload: data
  });
}

function setSalesParameters(dispatch, data) {
  dispatch({
    type: "SET_SALES_PARAMETERS",
    payload: data
  });
}

function setBackgroundPiture(dispatch, data) {
  dispatch({
    type: "SET_BACKGROUND_PICTURE",
    payload: data
  });
}

function setClientCurrency(dispatch, data) {
  dispatch({
    type: "SET_CLIENT_CURRENCY",
    payload: data
  });
}


function setRgpdParameters(dispatch, data) {
  dispatch({
    type: "SET_RGPD_PARAMETERS",
    payload: data
  });
}

